import React, {useEffect, useState} from 'react';
import Home from './Home';
import Home2 from './Home2';

const CreateAccount = () => {
    const [currentTab, setCurrentTab] = useState('')
    const [data, setData] = useState()

    useEffect(() => {
        setCurrentTab('page1')
    }, [])

    useEffect(() => {
        console.log(data)
    }, [data])
  return (
    <div>
        {
            currentTab === 'page1' && <Home setData={setData} data={data} setCurrentTab={setCurrentTab}/> 
        }

        {
            currentTab === 'page2' && <Home2 data={data} setCurrentTab={setCurrentTab}/>
        }
      
      
    </div>
  );
}

export default CreateAccount;
